export const swapcontractConstants = {
  SWAPCONTRACT_SELECTED: "SWAPCONTRACT_SELECTED",
};
